




















import { mapGetters } from "vuex";
import { App, General } from "@/utils/constants";
import { showErrorMessage } from "@/utils/messageUtility";
export default {
  name: "DocumentValidateInput",
  data() {
    return {
      App,
      General,
      code: ""
    };
  },
  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },
  methods: {
    submitClick(event: Event) {
      event.preventDefault();
      this.validate();
    },

    validate() {
      if (this.code) {
        this.$router.push({
          path: "/validar-documento",
          query: { hash: this.code }
        });
      } else {
        showErrorMessage(`${this.General.TYPE_IT_SEARCH}.`, false);
      }
    }
  }
};
